import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ForbrukService } from 'src/app/services/forbruk/forbruk.service';
import { ChartType } from 'src/app/services/forbruk/forbruk.types';

@Component({
  selector: 'app-viewpicker',
  templateUrl: './viewpicker.component.html',
  styleUrls: ['./viewpicker.component.scss']
})
export class ViewpickerComponent implements OnInit {
  _chartTypes: ChartType;
  subscription: Subscription;
  constructor(private _forbrukService: ForbrukService) {}

  ngOnInit() {
    this.subscription = this._forbrukService
      .getChartType()
      .subscribe((chartTypes) => {
        this._chartTypes = chartTypes;
      });
  }

  ngOnDestory() {
    this.subscription?.unsubscribe();
  }

  setChartType(chart: string) {
    for (const key in this._chartTypes) {
      if (key !== chart) {
        this._chartTypes[key].active = false;
      } else {
        this._chartTypes[key].active = true;
      }
    }
    this._forbrukService.setChartType(this._chartTypes);
  }
}
